import { render, staticRenderFns } from "./ProductRowForm.vue?vue&type=template&id=5408b157&scoped=true&"
import script from "./ProductRowForm.vue?vue&type=script&lang=js&"
export * from "./ProductRowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408b157",
  null
  
)

export default component.exports